import React, { useState, useCallback } from 'react'
import CreditOptions from '../CreditOptions/CreditOptions'
import * as Styled from './CreditPlanLink.styles'

const CreditPlanLink = ({ productInfo, AddToTrolley, ArgosCardPlan }) => {
  const [show, setShow] = useState(false)

  const { periodType, periodDuration, apr } = ArgosCardPlan || {}

  const isBuyNowPayLater = periodDuration > 0

  const creditOptionsProps = {
    productId: productInfo?.partNumber,
    periodType,
    periodDuration,
    isBuyNowPayLater,
    AddToTrolley,
    apr
  }

  const toggleDrawer = useCallback(() => setShow(prevShow => !prevShow), [])

  return (
    <>
      <Styled.Container
        onClick={() => {
          toggleDrawer()
        }}
        tabIndex='0'
        id='credit-card-link'
        data-test='credit-card-link'
      >
        <Styled.StyledBox as='div' border={{ radius: 'lg', size: 'sm' }}>
          <Styled.Label>
            <Styled.LabelImage
              src='//media.4rgos.it/i/Argos/argos-card-2024'
              width='64'
              height='40'
              data-test='argos-card-label-image'
              alt='argos-card-image'
            />
            <Styled.TextContainer>
              {periodDuration === 0 ? (
                'Spread the cost with an Argos Card'
              ) : (
                <>
                  <strong>Pay no interest</strong> when you pay your full balance within{' '}
                  <strong>
                    {periodDuration} {periodType?.toLowerCase()}*
                  </strong>
                </>
              )}
            </Styled.TextContainer>
          </Styled.Label>
          <Styled.Terms>
            *Representative <strong>{apr}% APR</strong> variable. <Styled.Link>Learn more</Styled.Link>
          </Styled.Terms>
        </Styled.StyledBox>
      </Styled.Container>
      <CreditOptions
        data-test='credit-options'
        {...creditOptionsProps}
        show={show}
        toggleCreditOptions={toggleDrawer}
      />
    </>
  )
}

export default CreditPlanLink
